import { createTheme } from "@material-ui/core/styles";

const themeStyle = createTheme({
  palette: {
    primary: {
      main: '#42a5f5',
    },
    text: {
      secondary: 'white',
    },
    danger: {
      main: 'red'
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'Arial',
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default themeStyle;